import React from 'react';
import './RequiredStar.css';

export default function RequiredStar () {
    return (
        <span className='required-star'>*</span> 
    );
  }

